import { ShieldAlert } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { messages } from '@/i18n';
import { AuthScreenLayout } from './AuthScreenLayout';

/**
 * Terminal state, and the most important screen in this slice.
 *
 * Invite-only onboarding populates the Firebase project and the backend user
 * table by two separate actions, so "valid token, unknown user" is normal:
 * invited but not yet provisioned, or access revoked.
 *
 * There is deliberately no "try again" and no sign-out here. The Firebase
 * sign-in succeeded — retrying it succeeds again and returns the user to this screen,
 * forever. This route also sits OUTSIDE SessionGuard: the guard that redirects
 * here is the one that failed, and nesting it inside would make this screen
 * unreachable in exactly the situation it exists for.
 */
export function AccessNotProvisioned() {
  return (
    <AuthScreenLayout title={messages.notProvisioned.title}>
      <Alert variant="warning">
        <ShieldAlert aria-hidden />
        <AlertDescription>
          <p>{messages.notProvisioned.body}</p>
          <p className="mt-2">{messages.notProvisioned.action}</p>
        </AlertDescription>
      </Alert>
    </AuthScreenLayout>
  );
}
